import { Effects } from 'chessboard/plugins/effects/renderer/types';

export const missedWin = `<g id="missed_win">
    <g>
      <path class="${Effects.ClassNames.Shadow}" opacity="0.3" d="M9,.5a9,9,0,1,0,9,9A9,9,0,0,0,9,.5Z"></path>
      <path class="${Effects.ClassNames.Background}" fill="#dbac16" d="M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z"></path>
    </g>
    <g>
      <g class="${Effects.ClassNames.ComponentShadow}" opacity="0.2">
        <rect x="2.74" y="8.1" width="12.51" height="3.11" rx="0.36"></rect>
      </g>
      <rect class="${Effects.ClassNames.Component}" fill="#fff" x="2.74" y="7.6" width="12.51" height="3.11" rx="0.36"></rect>
    </g>
  </g>`;
